export abstract class GenericClass {

    public static permissionObj = {
        isJRSalesforceEnabled : "JR Salesforce App",
        isNewVariablePopupEnabled : "New Variable Popup",
        isConferenceLinkToolEnabled : "Conference Link Tool"
    };
}


// WEBPACK FOOTER //
// ./src/app/shared/extClasses/genericMethod.ts